import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Container, Col } from "react-bootstrap";
import "../CodeOverview/CodeOverview.scss";
import ReactMarkdown from "react-markdown";
import Scrollbars from "react-custom-scrollbars-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faDownload, faCheck } from "@fortawesome/free-solid-svg-icons";

function UnitTestResult() {
  const unitTestData = useSelector((state) => state.unitTest?.unitTest);
  const [copied, setCopied] = useState(false);

  const formatUnitTestData = (data) => {
    if (!data || !data["unit_test"]) return "";
    
    return data["unit_test"].map((item) => {
      let formatted = `${item.generated_text}\n\n`;
      if (item.test_output) {
        formatted += `File: ${item.test_output.file}\n`;
        if (item.test_output.stdout) {
          formatted += `Standard Output:\n${item.test_output.stdout}\n`;
        }
        if (item.test_output.stderr) {
          formatted += `Standard Error:\n${item.test_output.stderr}\n`;
        }
      }
      return formatted;
    }).join("\n");
  };

  const copyToClipboard = () => {
    const formattedText = formatUnitTestData(unitTestData);
    navigator.clipboard.writeText(formattedText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };

  const downloadResult = () => {
    const formattedText = formatUnitTestData(unitTestData);
    const element = document.createElement("a");
    const file = new Blob([formattedText], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = "UnitTestResult.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const renderUnitTestData = (data) => {
    if (!data || !data["unit_test"]) return null;
    
    return data["unit_test"].map((item, index) => (
      <div key={index}>
        <ReactMarkdown className="overview-text">
          {item.generated_text}
        </ReactMarkdown>
        {item.test_output && (
          <div>
            <h3>Test Output:</h3>
            <h4>File: {item.test_output.file}</h4>
            {item.test_output.stdout && (
              <div>
                <h5>Standard Output:</h5>
                <pre>{item.test_output.stdout}</pre>
              </div>
            )}
            {item.test_output.stderr && (
              <div>
                <h5>Standard Error:</h5>
                <pre>{item.test_output.stderr}</pre>
              </div>
            )}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div className="page-wrapper code-overview-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Unit Test Results</h2>
            <div className="code-overview-wrapper">
              {unitTestData && (
                <>
                  <Row>
                    <Col>
                      <div className="overview-text-wrapper">
                        <button className="copy-btn" onClick={copyToClipboard}>
                          <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                        </button>
                        <Scrollbars>
                          {renderUnitTestData(unitTestData)}
                        </Scrollbars>
                      </div>
                      <div className="text-end">
                        <button className="download-btn" onClick={downloadResult}>
                          <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download Unit Test Results</span>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default UnitTestResult;